import { useContext } from "react";
import { AppContext } from "../types";
import ElectionsDataContext from "../context/ElectionsDataContext";

export default function useElectionsData() {
  const context = useContext<AppContext>(ElectionsDataContext);

  if (!context) {
    throw new Error("Data not available!");
  }

  return context;
}
